/* eslint-disable global-require */
const ICONS = {
  students: require('../../images/icon-large-students.svg'),
  teachers: require('../../images/icon-large-teachers.svg'),
  administrators: require('../../images/icon-large-administrators.svg'),
  faqs: require('../../images/icon-large-faqs.svg'),
  requirements: require('../../images/icon-large-requirements.svg'),
  contact: require('../../images/icon-large-contact.svg'),
  fourofour: require('../../images/icon-large-404.svg'),
  quickstart: require('../../images/icon-large-quickStart.svg'),
  videos: require('../../images/icon-large-videos.svg'),
};
/* eslint-enable global-require */

export default ICONS;



// WEBPACK FOOTER //
// ./src/components/icons/icons.js